import Vue from 'vue';

export const layers = {
  namespaced: true,
  state: {
    useNewOrdering: false,
    layers: {},
    legend: [],
    collections: [],
    active: [],
    isMapbox: false,
  },
  mutations: {
    SET_LAYER_ORDERING(state, type) {
      state.useNewOrdering = true;
    },
    ADD_LEGEND(state, layer) {
      state.legend.push(layer);
    },
    SET_LAYER_STATE(state, {layer, active = false, message = null} = {}) {
      let currentstate = state.layers[layer].mapstate || {
        active, message
      }

      Vue.set(state.layers[layer], 'mapstate', {
        ...currentstate,
        active,
        message
      })

    },
    ADD_ACTIVE_LAYER(state, layer) {
      state.active.push(layer);
    },
    REMOVE_ACTIVE_LAYER(state, layer) {
      state.active.splice(state.active.indexOf(layer), 1);
    },
    SET(state, {
      layers,
      collections
    }) {
      /**
       * Create a dummy collection to hold all the layers
       */
      if (layers && !collections) {
        collections = [{
          title: 'Layers',
          layers: Object.keys(layers)
            .filter(layKey => layers[layKey].type === 'layer'),
        }];
      }

      // Set the zIndex for each layer based on its collection and position in the collection
      const legacyOrdering = (collection, colIdx) => {
        console.log('LEGACY')
        collection.layers.forEach((layer, layIdx) => {
          const formattedLayerIndex = ('0' + layIdx).slice(-2);
          if (layers[layer]) {
            layers[layer].zIndex = `${colIdx}.${formattedLayerIndex}`;
          }
        })
      };

      // New ordering puts base layers at the bottom and groups all other layers above
      const newOrdering = (collection, collectionZIndex) => {
        collection.layers.forEach((layer, layIdx) => {
          console.dir(layer);
          const layerZIndex = (collection.layers.length || 0) - layIdx;
          const multiplier = collection.type === 'base' ? 1 : 1000;
          const formattedLayerIndex = (`0${layerZIndex}`).slice(-2);
          console.log(formattedLayerIndex);
          if (layers[layer]) {
            layers[layer].zIndex = Number(`${collectionZIndex * multiplier}.${formattedLayerIndex}`);
            console.log('LAYER INDEX', layers[layer].zIndex);
          }
        });
      };

      collections.forEach((collection, colIdx) => {
        console.log('NEW ORDERING', state.useNewOrdering);

        // Sort the layers in the collection based on their original index
        collections[colIdx].layers = collection.layers.sort((a, b) => {
          if (layers[a] && layers[b]) {
            return layers[a].index - layers[b].index;
          }
          return 0;
        });
        if (state.useNewOrdering) {
          const newColIdx = (collections.length + 1) - colIdx;
          return newOrdering(collection, newColIdx);
        }

        return legacyOrdering(collection, colIdx);
      });

      state.layers = layers;
      state.collections = collections;
    },
  },
  actions: {
    ADD_LAYER({
      state,
      commit,
      getters,
      dispatch,
      rootGetters,
    }, {
      layer,
      checkWatermark
    }) {
      console.log('ADD');
      console.dir(layer);
      if (!layer) return;
      let minResolution = 0;
      let maxResolution = Infinity;

      if (layer.minscale) {
        minResolution = this._vm.$MAP.getResolutionFromScale(layer.minscale);
        console.log(`MIN RESOLUTION: ${minResolution}`);
      }

      if (layer.maxscale) {
        maxResolution = this._vm.$MAP.getResolutionFromScale(layer.maxscale);
        console.log(`MAX RESOLUTION: ${maxResolution}`);
      }

      if (!layer.epsg) {
        layer.epsg = rootGetters.CONFIG.projection.split(':')[1];
      }

      const getLayerExtent = epsg => GOX.Transform(rootGetters.GET_EXTENT, this._vm.$MAP.getView()
        .getProjection()
        .getCode(), `EPSG:${epsg}`);

      if (layer.ows_source === 'external') {
        if (layer.ows_type === 'xyz') {
          this._vm.$MAP.addLayer(new GOX.Layer.XYZ({
            id: layer.layerid,
            // projection: `EPSG:${layer.epsg}`,
            attribution: layer.copyright,
            minResolution,
            maxResolution,
            extent: rootGetters.GET_EXTENT,
            zIndex: layer.zIndex,
            url: layer.ows_host,
          }));
          commit('ADD_ACTIVE_LAYER', layer.layerid);
        } else {
          this._vm.$MAP.addLayer(new GOX.Layer.TileWMS({
            url: layer.ows_host,
            layers: layer.ows_layer || layer.layerid,
            attribution: layer.copyright,
            crossOrigin: getCrossOriginValue(layer),
            minResolution,
            maxResolution,
            id: layer.layerid,
            projection: `EPSG:${layer.epsg}`,
            opacity: layer.opacity / 100 || 1,
            zIndex: layer.zIndex,
          }));
          commit('ADD_ACTIVE_LAYER', layer.layerid);
        }
      } else if (layer.ows_type === 'wfs') {
        if (layer.metadata && layer.metadata.wfs_linkout) {
          dispatch('ENABLE_MAP_MOUSEOVER_EVENTS');
          dispatch('ENABLE_WFS_CLICK_EVENTS');
        }

        const styleFunc = function (feature) {
          const theStyle = new GOX.Style();
          const classItem = layer.classitem;
          const labelItem = layer.labelitem;
          console.log(`LABEL ITEM: ${labelItem}`);
          const classValue = feature.get(classItem) || '';
          const labelValue = feature.get(labelItem) || '';
          console.log(`LABEL VAL: ${labelValue}`);

          for (const klass in layer.classes_json) {
            const expression = layer.classes_json[klass].class_expression;
            if (classValue == expression || classItem == '' || classItem == null) {
              const sendObj = layer.classes_json[klass].object_style_json;
              return theStyle.JSONtoStyle(_.cloneDeep(sendObj), feature, labelValue);
            }
          }
        };
        this._vm.$MAP.addLayer(new GOX.Layer.WFS({
          layers: getLayerNameWithNamespace(layer),
          // projection: `EPSG:${layer.epsg}`,
          extent: rootGetters.GET_EXTENT,
          typename: layer.layerid,
          id: layer.layerid,
          crossOrigin: getCrossOriginValue(layer),
          zIndex: layer.zIndex,
          url: `/data/${layer.owner}/wfs?`,
          style: styleFunc,
        }));
        commit('ADD_ACTIVE_LAYER', layer.layerid);
      } else {
        let url = `/data/${layer.owner}/wms?`;

        if (layer.geoserver_host_id && layer.geoserver_host_id !== 'xmap-default') {
          url = `${layer.ows_host}/${layer.owner}_public/wms`;
        }

        this._vm.$MAP.addLayer(new GOX.Layer.WMS({
          url,
          layers: layer.layerid,
          attribution: layer.copyright,
          crossOrigin: getCrossOriginValue(layer),
          id: layer.layerid,
          minResolution,
          maxResolution,
          cql_filter: getters.gen_layerFilter(layer.filter),
          projection: `EPSG:${layer.epsg}`,
          opacity: layer.opacity / 100 || 1,
          zIndex: layer.zIndex,
        }));
        commit('ADD_ACTIVE_LAYER', layer.layerid);
      }
    },
    ENABLE_WFS_CLICK_EVENTS({ dispatch }) {
      this._vm.$MAP.on('singleclick', (e) => {
        this._vm.$MAP.forEachFeatureAtPixel(e.pixel, (feature, layer) => {
          dispatch('HANDLE_WFS_LINKOUT', {
            feature,
            id: layer.id,
          });
        });
      });
    },
    ENABLE_MAP_MOUSEOVER_EVENTS() {
      const highlightedFeatures = [];
      this._vm.$MAP.on('pointermove', ((e) => {
        highlightedFeatures.forEach((feature) => {
          feature.setStyle(null);
        });

        this._vm.$MAP.forEachFeatureAtPixel(e.pixel, (feature, layer) => {
          highlightedFeatures.push(feature);
          layer.setStyle(layer.getStyle());
          const theStyle = new GOX.Style();
          const styleObject = {
            stroke: {
              color: 'rgb(69,185,233)',
              width: 4,
            },
          };
          feature.setStyle(theStyle.JSONtoStyle(styleObject));
        });
      }));
    },
    FETCH_LAYER_STYLE({
      commit,
      rootGetters
    }, {
      id,
      owner
    }) {
      return new Promise((resolve, reject) => {
        console.log(`LAYER: ${id}`);
        const layerOwner = owner;
        let layer = id;
        if (layer.indexOf(':') > -1) {
          layer = id.split(':')[1];
        }
        axios.get(`${process.env.VUE_APP_AUTH_URL}/layers/style/${layerOwner}/${layer}`)
          .then((res) => {
            commit('SET_LAYER_STYLE', {
              layer: id,
              style: res,
            });
            resolve();
          });
      });
    },
    HANDLE_WFS_LINKOUT({ state }, {
      feature,
      id
    }) {
      console.log(`HANDLE IT: ${id}`);
      console.dir(feature);
      if (state.layers[id]
        && state.layers[id].metadata
        && state.layers[id].metadata.wfs_linkout) {
        console.log('HANDLE LINK OUT');
        console.dir(feature);
        const linkVal = feature.get(state.layers[id].metadata.wfs_linkout);
        const col = state.layers[id].colparams.find(col => col.name === state.layers[id].metadata.wfs_linkout);
        console.dir(col);
        const hlinkVal = JSON.parse(col.hyperlink)
          .linkValue
          .replace(`#${state.layers[id].metadata.wfs_linkout}#`, linkVal);

        window.open(hlinkVal, '_blank');
      }
    },
    REMOVE_LAYER({
      state,
      commit,
      dispatch
    }, id) {
      this._vm.$MAP.getLayers()
        .forEach((layer) => {
          if (layer && layer.id === id) {
            this._vm.$MAP.removeLayer(layer);
          }
        });
      commit('REMOVE_ACTIVE_LAYER', id);
    },
  },
  getters: {
    gen_layerFilter: (state, getters, rootState, rootGetters) => (filter) => {
      console.log('GEN FILTER');
      console.dir(filter);
      if (!filter) {
        return null;
      }

      const filterCol = filter.property;
      let filterVal = '';

      if (filter.value === '%##orgid##') {
        filterVal = rootGetters.GET_ORGID;
        return `${filterCol} like '%@${filterVal}' OR ${filterCol} = '${filterVal}'`;
      }

      return null;
    },
    LAYERS(state) {
      return state.layers;
    },
    LEGEND(state) {
      return state.legend;
    },
    COLLECTIONS(state) {
      return state.collections;
    },
    /**
     * Returns the data required for layer control by merging layers and collections
     * and filtering hidden layers or entire collections as needed.
     * @param state
     * @constructor
     */
    LAYERCONTROL_DATA(state, getters, rootState, rootGetters) {
      return state.collections
        /**
         * Filter the collections before mapping the layers and collections together
         */
        .filter((col, idx) => {
          if (rootGetters.CONFIG.config.disableBasemaps) {
            return col.type !== 'base';
          }
          return col;
        })
        /**
         * Map the collections and layers together so they appear in
         * one object for the layer control
         */
        .map((col, idx) => {
          // Clone the collection
          const repCol = { ...col };

          // Map the layer objects into the collection
          repCol.layers = repCol.layers
            .filter((layer) => {
              const fullLayerId = `${repCol.id}:${layer}`;
              return state.layers[layer] && rootGetters.CONFIG.config.hiddenLayers.indexOf(fullLayerId) < 0;
            })
            .map(layer => state.layers[layer]);


          return repCol;
        });
    },
  },
};

function getCrossOriginValue(layer) {
  let crossOrigin = "use-credentials";
  if (layer.ows_source === "external") {
    crossOrigin = layer?.metadata?.cors !== undefined ? layer.metadata.cors : "anonymous";
  }

  console.log(`CORS: ${crossOrigin}`);

  return crossOrigin;
}

function getLayerNameWithNamespace(layer) {
  const layername = layer.ows_layer ? layer.ows_layer : layer.layerid;

  if (layer.ows_source === 'external') {
    return layername;
  }

  if (layer.schema) {
    return `${layer.schema}:${layername}`;
  }
  return `${layer.owner}:${layername}`;
}
